import React from 'react'
import PropTypes from 'prop-types'
import P from '../Typography/P'
import dictionary from '../../../dictionary'
import styles from './radio-group.module.scss'
import LegendsRadioGroup from './LegendsRadioGroup'

function NumberOfStickers(props) {
  const { onChange, name, current, content } = props
  return (
    <div className={styles.root}>
      <P size="small" className={styles.legend}>
        Количество наклеек
      </P>
      <LegendsRadioGroup
        defaultValue={current}
        value={current}
        ariaLabel={name}
        className={styles.group}
        onChange={(value) => onChange(name, value)}
      >
        {content.map(({ value, label, disabled }) => (
          <span
            className={styles.label}
            key={`${name}-${value}`}
            disabled={disabled}
          >
            {dictionary.item.numberOfStickers[label]}
          </span>
        ))}
      </LegendsRadioGroup>
    </div>
  )
}

NumberOfStickers.propTypes = {
  productName: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func,
}

export default NumberOfStickers
